import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import EnvironmentSettings from "../Models/EnvironmentSettings";
import firebaseConfig from "FirebaseConfig";
import TenantManager from "./TenantManager";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

var accessToken = "";

onAuthStateChanged(auth, (user) => {
  if (user) {
    accessToken = user.accessToken;
  }
});

class UsersApi {
  GetToken() {
    return accessToken;
  }

  // baseUrl = 'https://localhost:44362/api/'

  constructor() {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);
    //console.log("baseUrl: ", this.baseUrl);
  }

  // ************************ USERS **************************** */

  // users
  CreateUserUrl = "Users/CreateUser";
  SetUserSalaryUrl = "Users/SetUserSalary";
  GetUserByFirebaseIdUrl = "Users/GetUserByFirebaseId";
  SearchUsersUrl = "Users/SearchUsers";
  GetCurrentUserUrl = "Users/GetCurrentUser";
  GetUserTypesUrl = "Users/GetUserTypes";

  async GetCurrentUser(req) {
    const res = await fetch(this.baseUrl + this.GetCurrentUserUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async GetUserTypes(req) {
    const res = await fetch(this.baseUrl + this.GetUserTypesUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SetUserSalary(req) {
    const res = await fetch(this.baseUrl + this.SetUserSalaryUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async SearchUsers(req) {
    const res = await fetch(this.baseUrl + this.SearchUsersUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  GetPatientsOfTherapistUrl = "Users/GetPatientsOfTherapist";
  async GetPatientsOfTherapist(req) {
    const res = await fetch(this.baseUrl + this.GetPatientsOfTherapistUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async CreateUser(req) {
    const res = await fetch(this.baseUrl + this.CreateUserUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async GetUserByFirebaseId(req) {
    const res = await fetch(this.baseUrl + this.GetUserByFirebaseIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  // ************************ TherapistTypes **************************** */

  // therapists
  CreateNewTherapistTypeUrl = "Admin/CreateTherapistType";
  EdittherapistTypeTypeUrl = "Admin/EditTherapistType";
  GetTherapistTypeByIdUrl = "Admin/GetTherapistTypeById";
  GetTherapistTypeByIdUrl = "Admin/GetTherapistTypeById";
  SearchTherapistTypesUrl = "Admin/SearchTherapistTypes";
  DeleteTherapistTypesUrl = "Admin/DeleteTherapistType";
  AssignTherapistToTypeUrl = "Admin/AssignTherapistToType";
  GetDailyStatsUrl = "Admin/GetDailyStats";
  GetUsersPerMonthUrl = "Admin/GetUsersPerMonth";

  async GetUsersPerMonth() {
    const res = await fetch(this.baseUrl + this.GetUsersPerMonthUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
    });
    const data = await res.json();
    return data;
  }

  async GetDailyStats() {
    const res = await fetch(this.baseUrl + this.GetDailyStatsUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
    });
    const data = await res.json();
    return data;
  }

  async CreateNewTherapistType(req) {
    const reqBody = await fetch(this.baseUrl + this.CreateNewTherapistTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async AssignTherapistToType(req) {
    const reqBody = await fetch(this.baseUrl + this.AssignTherapistToTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    console.log(data);
    return data;
  }

  async SearchTherapistTypes(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.SearchTherapistTypesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async EditTherapistType(req) {
    const reqBody = await fetch(this.baseUrl + this.EdittherapistTypeTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async GetTherapistTypeById(req) {
    const reqBody = await fetch(this.baseUrl + this.GetTherapistTypeByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async DeleteTherapistTypes(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.DeleteTherapistTypesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  // ************************ EmployeeTypes **************************** */

  // Employee
  CreateNewEmployeeTypeUrl = "Admin/CreateEmployeeType";
  EditemployeeTypeTypeUrl = "Admin/EditEmployeeType";
  GetEmployeeTypeByIdUrl = "Admin/GetEmployeeTypeById";
  SearchEmployeeTypesUrl = "Admin/SearchEmployeeTypes";
  DeleteEmployeeTypesUrl = "Admin/DeleteEmployeeType";
  AssignEmployeeToTypeUrl = "Admin/AssignEmployeeToType";

  async AssignEmployeeToType(req) {
    const reqBody = await fetch(this.baseUrl + this.AssignEmployeeToTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    console.log(data);
    return data;
  }

  async SearchEmployeeTypes(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.SearchEmployeeTypesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async DeleteEmployeeTypes(req) {
    //debugger;
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.DeleteEmployeeTypesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async CreateNewEmployeeType(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.CreateNewEmployeeTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async EditEmployeeType(req) {
    //debugger;

    const reqBody = await fetch(this.baseUrl + this.EditemployeeTypeTypeUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  async GetEmployeeTypeById(req) {
    const reqBody = await fetch(this.baseUrl + this.GetEmployeeTypeByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  CreateFeedbackReq = "Appointments/CreateFeedbackReq";

  async CreateFeedback({ tenant, ...req }) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.CreateFeedbackReq, {
      method: "POST",
      headers: {
        tenant: tenant,
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  SearchFeedbackStatisticsReq = "Appointments/SearchFeedbackStatisticsReq";

  async SearchFeedbackStatistics(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.SearchFeedbackStatisticsReq, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  getSessionsParentAndChildsReq = "Appointments/getSessionsParentAndChilds";

  async getSessionsParentAndChilds(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.getSessionsParentAndChildsReq, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  SearchAccountingSessionsStatisticsReq = "Appointments/SearchAccountingSessionsStatisticsReq";

  async SearchAccountingSessionsStatistics(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.SearchAccountingSessionsStatisticsReq, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  getUsersDataReq = "Appointments/UsersStatistics";

  async getUsersData(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.getUsersDataReq, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  getPatientsDataReq = "Appointments/GetPatients";

  async getPatients(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.getPatientsDataReq, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  SearchPatientHistoryEntriesReq = "Admin/SearchPatientHistoryEntries";

  async SearchPatientHistoryEntries(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.SearchPatientHistoryEntriesReq, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  DeletePatientHistoryEntryReq = "Admin/DeletePatientHistoryEntry";

  async DeletePatientHistoryEntry(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.DeletePatientHistoryEntryReq, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }

  SearchAccountingSessionWithNoPatientHistoryEntryUrl =
    "Accounting/GetAccountingSessionsHasNoPatientHistoryEntry";
  async SearchAccountingSessionWithNoPatientHistoryEntry(req) {
    console.log("req: ", req);
    const reqBody = await fetch(
      this.baseUrl + this.SearchAccountingSessionWithNoPatientHistoryEntryUrl,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.GetToken()}`,
          tenant: TenantManager.getTenant(this.GetToken()),
          "Content-type": "application/json",
        },
        body: JSON.stringify(req),
      }
    );

    const data = await reqBody.json();
    return data;
  }

  GetPackagesStatisticsReq = "Accounting/GetPackagesStatistics";

  async GetPackagesStatistics(req) {
    console.log("req: ", req);
    const reqBody = await fetch(this.baseUrl + this.GetPackagesStatisticsReq, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.GetToken()}`,
        tenant: TenantManager.getTenant(this.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await reqBody.json();
    return data;
  }
}

export default new UsersApi();
